export enum DeliveryIntegrationStatus {
    CONNECTED = 'connected'
};
